const hoursAddition = 0;

export const addDaysDate = (days, date) => {
    let d = new Date(date.valueOf());
    d.setDate(d.getDate() + days);
    return d;
} 

export const substractDaysDate = (days, date) => {
    let d = new Date(date.valueOf());
    d.setDate(d.getDate() - days);
    return d;
} 

export const buildDateTimeStr = (date) => {
    let d = new Date(date);
    return `Día ${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} Hora ${d.getHours() + hoursAddition}:${d.getMinutes()}`;
}